import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import AnnouncementNewsCard from "@/components/Cards/AnnouncementNewsCard";
import Loader from "@/components/Loader/loader";
import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const AnnouncementNews: React.FC = () => {

    const { category } = useParams<{ category: string }>();
    const [targetPopulate, setTargetPopulate] = useState("677f804fd2c0311ca14f4f02");
    const [breadcrumbChild, setBreadcrumbChild] = useState<string>("");

    useEffect(() => {
        if (category === "haberler") {
            setTargetPopulate("677f7955d2c0311ca14f3f98")
        } else {
            setTargetPopulate("677f804fd2c0311ca14f4f02")
        }
    }, [category])

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: `/v1/main-module/677f779fd2c0311ca14f3c54/collection/${targetPopulate}/detail?list_related=true&module_populate=677f7929d2c0311ca14f3e8b`,
        service: "CMS_PROC",
        options: {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    })

    useEffect(() => {
        if (data && data.title) {
            setBreadcrumbChild(data.title);
        }
    }, [data])

    return (
        <>
            <BreadCrumb title="Haberler ve Duyurular" parent="Haberler ve Duyurular" child={breadcrumbChild} />
            {(isLoading === false && data) ? (
                <>
                    <section className="ls section_padding_100">
                        <div className="container">
                            <div className="row">
                                <h3>{data?.title}</h3>
                                {data.populated?.İçerikler?.records?.map((item: any, index: number) => (
                                    <AnnouncementNewsCard
                                        key={index} data={item} isLoading={isLoading}
                                    />
                                ))}
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <Loader />
            )}

        </>
    )
}

export default AnnouncementNews;